export default class LineupPlayersSnippetNotFoundError extends Error {}
